<template>
  <span
    class="absolute bottom-2 right-3 text-xxs transition-colors"
    :class="contentLength > MAX_CHAR_LENGTH ? 'text-red-400' : 'text-gray-400'"
  >
    {{ contentLength || '0' }}/{{ MAX_CHAR_LENGTH }}
  </span>
</template>

<script>
import { MAX_CHAR_LENGTH } from '@/Utils/vice-constants';

export default {
  name: 'CharacterCount',
  props: {
    section: {
      type: String,
    },
  },
  computed: {
    contentLength() {
      return this.section?.replace(/(<([^>]+)>)/gi, '').length;
    },
  },
  setup() {
    return {
      MAX_CHAR_LENGTH,
    };
  },
};
</script>

<style scoped></style>
